import { Directive } from '@angular/core';
import { Injectable, } from '@angular/core';
import swal from 'sweetalert2';
 @Directive({
    selector: 'app-sweetalert'
  })
  @Injectable()
  export class sweetalert {
    constructor() {

    }
    errorsweertalert(msg:String):any{
        const Toast = swal.mixin({
          toast: true,
          position: 'center',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', swal.stopTimer)
            toast.addEventListener('mouseleave', swal.resumeTimer)
          }
        })
        
       return Toast.fire({
          icon: 'error',
          title: msg,
        })
    }

    success_sweertalert(msg:string):any{
        const Toast = swal.mixin({
          toast: true,
          position: 'center',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', swal.stopTimer)
            toast.addEventListener('mouseleave', swal.resumeTimer)
          }
        })
        
       return Toast.fire({
          icon: 'success',
          title: msg,
         
        })
      
       
    }

    UTP_sweertalert():any{
        const Toast = swal.mixin({
          toast: true,
          position: 'center',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', swal.stopTimer)
            toast.addEventListener('mouseleave', swal.resumeTimer)
          }
        })
        
       return Toast.fire({
          icon: 'warning',
          title: 'Sorry, unable to process your request'
        })
    }

    Invalidentry_sweertalert():any{
        const Toast = swal.mixin({
          toast: true,
          position: 'center',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', swal.stopTimer)
            toast.addEventListener('mouseleave', swal.resumeTimer)
          }
        })
        
       return Toast.fire({
          icon: 'warning',
          title: 'Selected file is invalid'
        })
    }

    Mandatory_sweertalert():any{
      const Toast = swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
          toast.addEventListener('mouseenter', swal.stopTimer)
          toast.addEventListener('mouseleave', swal.resumeTimer)
        }
      })
      
     return Toast.fire({
        icon: 'warning',
        title: "please fill all mandatory fields"
      })
  }

  MSG_sweertalert(msg:string):any{
    const Toast = swal.mixin({
      toast: true,
      position: 'center',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', swal.stopTimer)
        toast.addEventListener('mouseleave', swal.resumeTimer)
      }
    })
    
   return Toast.fire({
      icon: 'warning',
      title: msg
    })
}
  }